import { performRequestTypePOST } from "../utils/servicesUtils";

// Login Service: Authenticates a user with email and password
export const loginService = async (email, password, mobile) =>
  performRequestTypePOST("/api/auth/login/", {
    body: { email, password, mobile },
    errorMessage: "Login failed",
  });

// Extra accounts service: Gets the account change options for the user
export const availableAccountsForUser = async () =>
  performRequestTypePOST("/api/auth/mint-demo-roles/", {
    errorMessage: "Fetch for available accounts failed",
  });

// expected body
// {
//   "configs": [
//     {
//       "role": "owner",
//       "email": "user@example.com"
//     }
//   ]
// }
export const createAccountsForAccountSwitcher = async (body) =>
  performRequestTypePOST("/api/auth/mint/demo/roles/config/", {
    ...(body && { body }),
    errorMessage: "Failed to create the accounts for the switcher",
  });

// Authentication Selection Service: Defines the auth method that the user will use for their login attempt
export const authMethodSelector = async (email, method, reset_password = false) => {
  const queryParams = new URLSearchParams({ email, method, reset_password });
  return performRequestTypePOST(`/api/auth/auth-method/?${queryParams.toString()}`, {
    errorMessage: "Failed to select the authentication method",
  });
};

// 2FA Authenticator Setup Service: Sets up the authenticator by verifying it with a code
export const setupTOTPService = async (email, totpInitialCode) =>
  performRequestTypePOST("/api/auth/setup-totp/", {
    body: { email, totp_code: totpInitialCode },
    errorMessage: "TOTP setup failed",
  });

// 2FA Authenticator Reset service: Removes the current authenticator from the user's account
export const resetTOTP = async (userId) =>
  performRequestTypePOST(`/api/auth/reset/totp/${encodeURIComponent(userId)}/`, {
    errorMessage: "A connection error occurred while trying resetTOTP",
  });

// TOTP Verification Service: Verifies the TOTP code during authentication using an authenticator app
export const verifyTOTPService = async (email, totpCode, { reset_password = false, password_change_required = false, remember = false } = {}) => {
  const queryParams = new URLSearchParams({ reset_password, password_change_required, remember });
  return performRequestTypePOST(`/api/auth/verify-totp/?${queryParams.toString()}`, {
    body: { email, totp_code: totpCode },
    errorMessage: "TOTP verification failed",
  });
};

// Email Code Verification Service: Verifies the code sent to a user's email during authentication using an email address
export const verifyEmailCodeService = async (email, code, { reset_password = false, password_change_required = false, remember = false } = {}) => {
  const queryParams = new URLSearchParams({ email, code, reset_password, password_change_required, remember });
  return performRequestTypePOST(`/api/auth/email-code/?${queryParams.toString()}`, {
    errorMessage: "Email code verification failed",
  });
};

/**
 * Single dedicated refresh-token service.
 * All refresh calls must go through this function — no ad-hoc fetch elsewhere.
 * @param {string} sessionId
 * @param {string} currentToken
 * @returns {Promise<{ access_token: string }>}
 */
export const refreshTokenService = async (sessionId, currentToken) =>
  performRequestTypePOST(
    `/api/services/auth/refresh-token/?sessionId=${encodeURIComponent(sessionId)}`,
    {
      tokenOverride: currentToken,
      errorMessage: "Token refresh failed",
    },
  );